import moment from 'moment';
import tinycolor from 'tinycolor2';
import { ACTION_DEMO_START } from '../../actions/demo';

export default function eventReducer(state, action) {
    if (!state) {
        state = {
            loaded: false,
            isWelcomeScreenShown: false,
            lastReceivedUpdates: null,
        };
    }

    switch (action.type) {
        case ACTION_DEMO_START:
        case 'SINGLE_EVENT_UPDATE':
            state = Object.assign({}, state, action.event, {
                fetchTime: action.fetchTime ? moment(action.fetchTime) : state.fetch,
                loaded: true,
                _local: {
                    start: moment(action.event.start).local(),
                    end: moment(action.event.end).local(),
                    // TODO: remove this and use the style variables
                    styles: {
                        button: {
                            color: 'white',
                            backgroundColor: action.event.settings.primary_color,
                            borderColor: action.event.settings.primary_color,
                        },
                        smallButton: {
                            borderColor: action.event.settings.primary_color,
                            backgroundColor: 'white',
                        },
                        button_white: {
                            color: action.event.settings.primary_color,
                            backgroundColor: 'white',
                        },
                        button_secondary: {
                            color: 'white',
                            backgroundColor: action.event.settings.secondary_color,
                        },
                        blocklink: {
                            color: tinycolor(action.event.settings.secondary_color).isDark() ? 'white' : 'black', //PREVIOUS VALUE: action.event.settings.block_text,
                            backgroundColor: action.event.settings.secondary_color,
                        },
                    },
                },
            });

            switch (action.event.data_type) {
                case 1: // Event
                    state._isEvent = true;
                    break;
                case 2: // Community
                    state._isCommunity = true;
                    break;
                default:
                    if (action.event.agenda_type) {
                        state._isAgenda = true;
                    } else {
                        console.warn('Unknown event type: ', action.event.data_type, action.event);
                    }
            }
            break;
        case 'UPDATE_QUESTION_CATEGORY':
            state = Object.assign({}, state, {
                question_categories: state.question_categories.map(qc => {
                    if (qc.id == action.questionCategoryId) {
                        return Object.assign({}, qc, action.payload);
                    }
                    return qc;
                }),
            });
            break;
        case 'UPDATE_OPEN_REQUIRED_ENRICHMENTS_COUNT':
            state = {
                ...state,
                open_required_enrichments_count: action.openRequiredEnrichmentsCount,
            };
            break;
        case 'EVENT_LOCAL_UPDATE':
            state = {
                ...state,
                ...action.event,
            };
            break;
        case 'SESSION_UPDATES':
            state = {
                ...state,
                lastReceivedUpdates: action.eventUpdates,
                isWelcomeScreenShown: state.isWelcomeScreenShown || !!action.eventUpdates.action_logs.find(update => update.action == 'welcome_read'),
            };
            break;
        case 'SUB_EVENT_UPDATE':
            state = {
                ...state,
                subevents: state.subevents.map(subevent => {
                    if (subevent.id == action.event.id) {
                        return {
                            ...subevent,
                            ...action.event,
                        };
                    }
                    return subevent;
                }),
            };
            break;
        case 'EVENT_CHANGE_PARTICIPANCE':
            if (state.id == action.eventId) {
                state = {
                    ...state,
                    joined: action.joined,
                    unregistered: !action.joined,
                };
                if (!action.joined) {
                    // free can_join flag (leaving means one more spot available)
                    // following update will replace the value if needed
                    state.can_join = true;
                }
            }
            if (state.subevents) {
                state = {
                    ...state,
                    subevents: state.subevents.map(se => eventReducer(se, action)),
                };
            }
            break;
    }

    return state;
}
